import { excludeForwardProps as e } from "../../../common/utils/excludeForwardProps.js";
import { styled as t, Skeleton as o, Divider as r } from "@mui/joy";
import i from "@mui/joy/Box";
import a from "@mui/joy/Stack";
import n from "@mui/joy/Typography";
import l from "@mui/material/SvgIcon";
const m = t("div")(({ theme: e2 }) => ({ display: "flex", alignItems: "center", gap: e2.spacing(1) })), p = t(l)(({ theme: e2 }) => ({ color: e2.palette.text.primary, display: "block", "& > path": { fill: e2.palette.text.primary } })), c = t(n)(({ theme: e2 }) => ({ fontSize: e2.fontSize.xl, fontWeight: 600, color: e2.palette.neutral[800] })), f = t(r)(({ theme: e2 }) => ({ background: e2.palette.neutral[600] })), s = t(o)`
  max-width: ${({ mw: e2 }) => e2};
`, h = t(a)(({ theme: e2 }) => `
  flex-direction: row;
  align-items: center;
  margin-left: ${e2.spacing(5)};
  gap: ${e2.spacing(1)};
  
  & > .MuiTypography-root:first-of-type {
    color: ${e2.palette.neutral[800]}
  }
`), u = t(i, { shouldForwardProp: e("hasChildren") })(({ hasChildren: e2 }) => ({ display: "flex", flexWrap: "wrap", alignItems: e2 ? "center" : "flex-start", flexDirection: e2 ? "row" : "column", justifyContent: "space-between" }));
export {
  m as Container,
  u as StyledPageTitle,
  s as StyledSkeleton,
  h as StyledSubtitle,
  f as SubtitleDivider,
  p as SvgIcon,
  c as Title
};
//# sourceMappingURL=styled.js.map
